import React, { Component, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardImg,
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import DropZone from 'react-dropzone'
import Loader from '../../../commons/loader';
import Services from './services';
import { ProgressButton } from '../../../commons/ProgressButton';
import { DatetimePicker, ImageCard} from '../../../commons/controls';
import _ from 'lodash';
import moment from 'moment';
import {CustomOption} from '../../../commons/customOption';
import SwitchButton from '../../../commons/SwitchButton';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';

class EloadasForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //UTILS
      angolNyelv: false,
      magyarSwitchButton: true,
      isFelvitel: null,
      eloadasId: null,
      saveButtonLoading: false,
      importButtonLoading: false,
      mufajOptions: [],
      korhatarOptions: [],
      szereploOptions: [],
      pozicioOptions: [],
      deleteKorhatarModal: false,
      deleteMufajModal: false,
      deleteSzereploModal: false,
      mafabModal: false,
      jelenetkepIndex: null,

      // VALUES
      formStatusz: 'AKTIV',
      formCim: '',
      formCimAngol: '',
      formEredeticim: '',
      formMegjelenesEve: '',
      formBemutato: null,
      formRendezo: '',
      formSzereplok: [],
      formKorhatar: null,
      formLeiras: '',
      formLeirasAngol: '',
      formForras: '',
      formElozetes: '',
      formElozetesAngol: '',
      formIdotartam: '',
      formKepPozicio: null,
      formMufajok: [],
      formMufajokAngol: [],
      formObjects: [],
      formPlakat: null,
      formJelenetkepek: [],

      statuszok: [],
      statuszOptions: [],
      filterOptions: {},
    }
  }

  componentDidMount = () => {
    this.selected = false;
    let isFelvitel = true;
    let id = null;

    if(this.props.type === 'MOD'){
      const params = new URL(window.location.href).searchParams;
      id = params.get('id');
      isFelvitel = false;
    }

    this.setState({
      formType: this.props.type,
    }, () => {
      this.initForm();
      this.getData(id, isFelvitel);
      this.loadMufajokOptions();
      this.loadKorhatarOptions();
      this.loadSzereplokOptions();
    });
  }

  getData = (id, isFelvitel) => {
    this.setState({
      formStatus: 'LOAD',
      eloadasId: id
    });

    if(!isFelvitel)
    Promise.all([
      //this.initForm(id, isFelvitel)
      this.getEloadas(id),
    ])
    .then(() => {
      this.setState({
        tipusCardStatus: 'DATA'
      });
    })
    .catch(() => {
      this.setState({
        tipusCardStatus: 'NETW'
      });
    });
  }

  onDropPlakat = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.formPlakat || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          type: 'PLAKAT',
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          //id: Lib.Browser.uuidv4(),
        });
        this.setState({ formPlakat: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  onDropJelenetKepek = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.formJelenetkepek || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          type: 'JELENET',
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          //id: Lib.Browser.uuidv4(),
        });
        this.setState({ formJelenetkepek: files });
      };
      reader.readAsBinaryString(file);
    });
  }
  
  loadMafabData = (event, submitObj) => {
    this.setState({importButtonLoading : true}, () => {
      Services.loadMafabData(submitObj, (err, res) => {
        if (!err) {
           this.setState({
            formStatus: 'DATA',
            formStatusz: 'AKTIV',
            formCim: this.nullToString(res[0].title_hu),
            formEredeti: this.nullToString(res[0].title_original),
            formMegjelenesEve: this.nullToString(res[0].year),
            formBemutato: res[0].premier ? TimeFormatter.formatIso(res[0].premier) : null,
            formRendezo: res[0].director && res[0].director.map(d =>  d.name).join(),
            formLeiras: res[0].description,
            formForras: res[0].url,
            formElozetes: res[0].video ? 'https://www.youtube.com/embed/' + res[0].video : null,
            formIdotartam: this.nullToString(res[0].runtime),
            formMufajok: res[0].genres && res[0].genres.map(g => g.name).map( g => {return {label : g}}),
            formSzereplok: res[0].actors && res[0].actors.map(a => a.name).map( a => {return {label : a}}),
            formKorhatar: { label: res[0].minage},
            formPlakat: res[0].image ? {
              src: res[0].image.replace(/\/thumb\/w\d{0,5}/, ''),
              url: res[0].image.replace(/\/thumb\/w\d{0,5}/, ''),
              docname: res[0].image.substring(res[0].image.lastIndexOf('/') + 1,res[0].image.length), 
              type: "PLAKAT"} : null,
            formJelenetkepek: res[0].pictures ? res[0].pictures.map(p => p.url.replace(/\/thumb\/w\d{0,5}/, ''))
            .map(p => {return {
              src: p,
              url: p, 
              type: "JELENET", 
              docname: p.substring(p.lastIndexOf('/') + 1 ,p.length),
            }}) : [],
            importButtonLoading : false
           }, () => {
             this.toggleMafabModal();
           });
        } else {
          this.setState({
            formStatus: 'NETW', 
            importButtonLoading : false
          });
        }
      });
    });
  }

  navToList = () => {
    this.props.globals.route.navigate(this.props.globals.public_url + '/admin/esemenyek/eloadasok');
  }

  toggleMafabModal = () => {
    this.setState(prevState => ({ mafabModal: !prevState.mafabModal }));
  }

  togglePlakatModal = () => {
    this.setState(prevState => ({ plakatModal: !prevState.plakatModal }));
  }

  toggleJelenetKepModal = (idx) => {
    this.setState(prevState => ({ jelenetKepModal: !prevState.jelenetKepModal, jelenetkepIndex: idx }));
  }

  getEloadas = (id) => {
    Services.getEloadas(id, (err, res) => {
      if (!err) {
        let obj = {
          currentId: id,
          formStatus: 'DATA',
          formStatusz: this.nullToString(res[0].allapot),
          formAzonosito: this.nullToString(res[0].azonosito),
          formCim: this.nullToString(res[0].cim),
          formEredeti: this.nullToString(res[0].eredeti),
          formMegjelenesEve: this.nullToString(res[0].megjeleneseve),
          formBemutato: res[0].bemutato,
          formRendezo: this.nullToString(res[0].rendezo),
          formLeiras:  this.nullToString(res[0].leiras),
          formForras: this.nullToString(res[0].forras),
          formElozetes: this.nullToString(res[0].elozetes),
          formIdotartam: this.nullToString(res[0].idotartam),
          formKepPozicio: res[0].pozicio ? {value: res[0].pozicio.name, label: res[0].pozicio.caption} : null,
          formMufajok: res[0].mufajok.filter(m => m.angol != true).map(m => ({value: m.id, label: m.nev})),
          formSzereplok: res[0].szereplok.map(sz => ({value: sz.id, label: sz.nev})),
          formKorhatar: res[0].korhatar ? {value: res[0].korhatar.id, label: res[0].korhatar.kod} : null,
          formPlakat: res[0].objects.find(eObj => "PLAKAT" === eObj.type.name),
          formJelenetkepek: res[0].objects.filter(eObj => "JELENET" === eObj.type.name),
        };
        if (this.state.angolNyelv == true) {
          obj.formCimAngol = this.nullToString(res[0].cimangol);
          obj.formLeirasAngol = this.nullToString(res[0].leirasangol);
          obj.formElozetesAngol = this.nullToString(res[0].elozetesangol);
          obj.formMufajokAngol = res[0].mufajok.filter(m => m.angol == true).map(m => ({value: m.id, label: m.nev}));
        }
        this.setState(obj);
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  loadMufajokOptions = () => {
    Services.listMufajok('', (err, res) => {
      if (!err) {
        this.setState({
          mufajOptions: res[0].map(m => ({value: m.id, label: m.nev, angol: m.angol}))
        });
      }
    });
  }

  loadSzereplokOptions = (input, callback) => {
    Services.listSzereplok(null, (err, res) => {
      if (!err) {
        this.setState({
          szereploOptions: res[0].map(m => ({value: m.id, label: m.nev}))
        });
      }
    });
  }

  loadKorhatarOptions = (input, callback) => {
    Services.listKorhatarok(null, (err, res) => {
      if (!err) {
        this.setState({
          korhatarOptions: res[0].map(k => ({value: k.id, label: k.kod}))
        });
      }
    });
  }

  initForm = (input, callback) => {
    Services.initEloadasForm((err, res) => {
      if (!err) {
        this.setState({
          pozicioOptions: res[0].pozicio.map(k => ({value: k.name, label: k.caption})),
          statuszOptions: res[0].statusz.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          angolNyelv: res[0].angolnyelv,
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMBEMUTATAS':
          this.setState({ formBemutato: (moment(e).startOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMBEMUTATAS':
          this.setState({ formBemutato: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  handleCreateMufaj = (newMufaj) => {
    Services.addMufaj({nev: newMufaj, kod: newMufaj, angol: !this.state.magyarSwitchButton}, (err, res) => {
      if (!err) {
        const mufajOptions = this.state.mufajOptions;
        const formMufajok = this.state.formMufajok;
        const formMufajokAngol = this.state.formMufajokAngol;
        let optionObj;
        const obj = { value: res[0].id, label: res[0].nev, angol: res[0].angol};
        if (this.state.magyarSwitchButton == true)
          optionObj = { formMufajok: [...formMufajok, obj] }
        else
          optionObj = { formMufajokAngol: [...formMufajokAngol, obj] }
        this.setState({ 
          mufajOptions: [...mufajOptions, obj],
          ...optionObj
        });
      }
    });  
  }

  handleCreateKorhatar = (newKorhatar) => {
    Services.addKorhatar(newKorhatar, (err, res) => {
      if (!err) {
        const korhatarOptions = this.state.korhatarOptions;
        const obj = { value: res[0].id, label: res[0].kod};
        this.setState({ 
          korhatarOptions: [...korhatarOptions, obj],
          formKorhatar: obj
        });
      }
    });  
  }

  handleCreateSzereplo = (newSzereplo) => {
    Services.addSzereplo(newSzereplo, (err, res) => {
      if (!err) {
        const { formSzereplok, szereploOptions } = this.state;
        const obj = { value: res[0].id, label: res[0].nev};
        this.setState({ 
          szereploOptions: [...szereploOptions, obj],
          formSzereplok: [...formSzereplok, obj]
        });
      }
    });  
  }

  deleteMufaj = (id) => {
    Services.deleteMufaj(id, (err) => {
      if (!err) {
        const mufajOptions = this.state.mufajOptions;
        const formMufajok = this.state.formMufajok;
        const formMufajokAngol = this.state.formMufajokAngol;
        this.setState({ 
          mufajOptions: mufajOptions.filter(mufaj => id != mufaj.value),
          formMufajok: formMufajok.filter(mufaj => id != mufaj.value),
          formMufajokAngol: formMufajokAngol.filter(mufaj => id != mufaj.value)
        });
      }
    });  
  }

  deleteKorhatar = (id) => {
    Services.deleteKorhatar(id, (err) => {
      if (!err) {
        this.setState({ formKorhatar: null });
        this.loadKorhatarOptions();
      }
    });  
  }

  deleteSzereplo = (id) => {
    Services.deleteSzereplo(id, (err) => {
      if (!err) {
        const szereploOptions = this.state.szereploOptions;
        const formSzereplok = this.state.formSzereplok;
        this.setState({ 
          szereploOptions: szereploOptions.filter(szereplo => id != szereplo.value),
          formSzereplok: formSzereplok.filter(szereplo => id != szereplo.value)
        });
      }
    });  
  }

  formarCreateLabel = (input) => (
    <span><i>Hozzáadás: </i> {input}</span>
  );

  submitForm = (e, submitObj) => {
    const {
      currentId,
      formCim,
      formCimAngol,
      formAzonosito,
      formEredeti,
      formBemutato,
      formMegjelenesEve,
      formRendezo,
      formLeiras,
      formLeirasAngol,
      formForras,
      formElozetes,
      formElozetesAngol,
      formIdotartam,
      formKepPozicio,
      formKorhatar,
      formMufajok,
      formMufajokAngol,
      formSzereplok,
      formPlakat,
      formJelenetkepek,
    } = this.state;

    const { formStatusz } = submitObj;
    
    this.setState({
      saveButtonLoading: true
    }, () => {
      if (this.props.type !== 'MOD') {
        let submitObj = {};
        let objects = [];
        objects.push(formPlakat);
        formJelenetkepek.forEach(j => objects.push(j));

        submitObj.cim = this.emptyOrNull(formCim);
        submitObj.allapot = this.emptyOrNull(formStatusz);
        submitObj.eredeti = this.emptyOrNull(formEredeti);
        submitObj.megjeleneseve = this.emptyOrNull(formMegjelenesEve);
        submitObj.bemutato =  formBemutato ? TimeFormatter.formatIso(formBemutato) : null;
        submitObj.rendezo = this.emptyOrNull(formRendezo);
        submitObj.leiras = this.emptyOrNull(formLeiras);
        submitObj.forras = this.emptyOrNull(formForras);
        submitObj.elozetes = this.emptyOrNull(formElozetes);
        submitObj.idotartam = this.emptyOrNull(formIdotartam);
        submitObj.pozicio =  formKepPozicio && formKepPozicio.value;
        submitObj.korhatar = formKorhatar ? {id: formKorhatar.value, kod: formKorhatar.label} : null;
        submitObj.mufajok = formMufajok ? formMufajok.map( fM => ({id: fM.value, nev: fM.label, kod:fM.label, angol: false})) : null;
        submitObj.szereplok = formSzereplok ? formSzereplok.map( fM => ({id: fM.value, nev: fM.label})) : null;
        if (this.state.angolNyelv == true) {
          submitObj.cimangol = this.emptyOrNull(formCimAngol);
          submitObj.leirasangol = this.emptyOrNull(formLeirasAngol);
          submitObj.elozetesangol = this.emptyOrNull(formElozetesAngol);
          let mufajokAngol = formMufajokAngol.map( fM => ({id: fM.value, nev: fM.label, kod:fM.label, angol: true}));
          if (submitObj.mufajok)
           submitObj.mufajok = submitObj.mufajok.concat(mufajokAngol);
          else
            submitObj.mufajok = mufajokAngol;
        }
        submitObj.objects = objects.map( o => {  
          return Object.assign(o || {} , {type:  o ? typeof o.type === "string" ? o.type : o.type.name : null});
        });
  
        Services.addEloadas(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Előadás felvéve!');
            this.navToList();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else {
        let submitObj = {};
        let objects = [];
        objects.push(formPlakat);
        formJelenetkepek.forEach(j => objects.push(j));
  
        submitObj.id = this.emptyOrNull(currentId);
        submitObj.cim = this.emptyOrNull(formCim);
        submitObj.azonosito = this.emptyOrNull(formAzonosito);
        submitObj.allapot = this.emptyOrNull(formStatusz);
        submitObj.eredeti = this.emptyOrNull(formEredeti);
        submitObj.megjeleneseve = this.emptyOrNull(formMegjelenesEve);
        submitObj.bemutato = formBemutato ? TimeFormatter.formatIso(formBemutato) : null;
        submitObj.rendezo = this.emptyOrNull(formRendezo);
        submitObj.leiras = this.emptyOrNull(formLeiras);
        submitObj.forras = this.emptyOrNull(formForras);
        submitObj.elozetes = this.emptyOrNull(formElozetes);
        submitObj.idotartam = this.emptyOrNull(formIdotartam);
        submitObj.pozicio =  formKepPozicio && formKepPozicio.value;
        submitObj.korhatar = formKorhatar ? {id: formKorhatar.value, kod: formKorhatar.label} : null;
        submitObj.mufajok = formMufajok.map( fM => ({id: fM.value, nev: fM.label, kod:fM.label, angol: false}));
        if (this.state.angolNyelv == true) {
          submitObj.cimangol = this.emptyOrNull(formCimAngol);
          submitObj.leirasangol = this.emptyOrNull(formLeirasAngol);
          submitObj.elozetesangol = this.emptyOrNull(formElozetesAngol);
          let mufajokAngol = formMufajokAngol.map( fM => ({id: fM.value, nev: fM.label, kod:fM.label, angol: true}));
          if (submitObj.mufajok)
            submitObj.mufajok = submitObj.mufajok.concat(mufajokAngol);
          else
            submitObj.mufajok = mufajokAngol;
        }
        submitObj.szereplok = formSzereplok.map( fM => ({id: fM.value, nev: fM.label}));
        submitObj.objects = objects.map( o => {
          return Object.assign(o || {} , {type:  o ? typeof o.type === "string" ? o.type : o.type.name : null});
        });
  
        Services.editEloadas(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Előadás módosítva!');
            this.navToList();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  renderFormTitle = () => {
    let title; 
      if (this.props.type === 'FEL') {
        title = 'Új előadás létrehozása';
      } else {
        title = 'Előadás módosítása';
      }
      return title;
  }

  // myDropZonePlakat = () => {
  //   const onDrop = useCallback(acceptedFiles => {
  //     acceptedFiles.forEach((file) => {
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         const fileAsBinaryString = reader.result;
  //         let files = this.state.formPlakat || [];
  //         files.push({
  //           content: btoa(fileAsBinaryString),
  //           uploadDate: new Date(),
  //           docname: file.name,
  //           type: 'PLAKAT',
  //           preview: file.preview,
  //           logo: false,
  //           mime: file.type || 'application/octet-stream',
  //           new: true,
  //           length: file.size,
  //           //id: Lib.Browser.uuidv4(),
  //         });
  //         this.setState({ formPlakat: files[0] });
  //       };
  //       reader.readAsBinaryString(file);
  //     });
  //   }, [])
  //   const { getRootProps, getInputProps } = useDropzone({onDrop})
  
  //   return (
  //     <div {...getRootProps()}>
  //       <input {...getInputProps()} />
  //       (
  //         <div className="dropzone-text">
  //           {'Kép feltöltése!'}
  //         </div>
  //       )
  //     </div>
  //   )
  // }

  // myDropZoneJelenet = () => {
  //   const onDrop = useCallback(acceptedFiles => {
  //     acceptedfiles.forEach((file) => {
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         const fileAsBinaryString = reader.result;
  //         let files = this.state.formJelenetkepek || [];
  //         files.push({
  //           content: btoa(fileAsBinaryString),
  //           uploadDate: new Date(),
  //           docname: file.name,
  //           type: 'JELENET',
  //           preview: file.preview,
  //           logo: false,
  //           mime: file.type || 'application/octet-stream',
  //           new: true,
  //           length: file.size,
  //           //id: Lib.Browser.uuidv4(),
  //         });
  //         this.setState({ formJelenetkepek: files });
  //       };
  //       reader.readAsBinaryString(file);
  //     });
  //   }, [])
  //   const { getRootProps, getInputProps } = useDropzone({onDrop})
  
  //   return (
  //     <div {...getRootProps()}>
  //       <input {...getInputProps()} />
  //       (
  //         <div className="dropzone-text">
  //           {'Kép feltöltése!'}
  //         </div>
  //       )
  //     </div>
  //   )
  // }


  renderForm = () => {
    const {
      formAzonosito,
      formCim,
      formCimAngol,
      formEredeti,
      formStatusz,
      formMegjelenesEve,
      formBemutato,
      formIdotartam,
      formRendezo,
      formLeiras,
      formLeirasAngol,
      formForras,
      formElozetes,
      formElozetesAngol,
      formPlakat,
      formJelenetkepek,
      formKepPozicio,
    } = this.state;

    let cimMezoString, mufajMezoString, elozetesMezoString, leirasMezoString;
    if (this.state.magyarSwitchButton == true) {
      cimMezoString = 'formCim';
      mufajMezoString = 'formMufajok';
      elozetesMezoString = 'formElozetes';
      leirasMezoString = 'formLeiras';
    } else {
      cimMezoString = 'formCimAngol';
      mufajMezoString = 'formMufajokAngol';
      elozetesMezoString = 'formElozetesAngol';
      leirasMezoString = 'formLeirasAngol';
    }

    return (
      <React.Fragment>
        {this.state.angolNyelv == true ? 
          <div className="col-md-12" style={{ textAlign: 'center', paddingBottom: '15px' }}>
            <SwitchButton
              active={this.state.magyarSwitchButton}
              trueLabel="Magyar"
              trueToggle={() => this.setState({ magyarSwitchButton: true })}
              trueWidth={100}
              falseToggle={() => this.setState({ magyarSwitchButton: false })}
              falseLabel="Angol"
              falseWidth={100}
            />
          </div>
          : <div />
        }
        <div className="row">
          <div className="col-md-4">
            <RFField
              name={cimMezoString}
              id={cimMezoString}
              label='Cím: *'
              value={this.state.magyarSwitchButton == true ? formCim : formCimAngol}
              onChange={this.handleInputChange}
              required
              maxLength="100"
            />
          </div>
          <div className="col-md-4" hidden={!this.state.magyarSwitchButton}>
            <RFField
              name="formEredeti"
              label='Eredeti cím: '
              id="formEredeti"
              value={formEredeti}
              onChange={this.handleInputChange}
              maxLength="100"
            />
          </div>
          <div className="col-md-4" hidden={!this.state.magyarSwitchButton}>
            <RFField
               name="formStatusz"
               id="formStatusz"
               label="Állapot: *"
               type="select"
               required
               value={formStatusz}
               selectOptions={this.state.statuszOptions}
            />
          </div>
        </div>
        {this.state.magyarSwitchButton == true ?
          <React.Fragment>
            <div className="row">
              <div className="col-md-4">
                <RFField
                  regex={['^[0-9]{4}$', '4 számjegyű mező!']}
                  label='Megjelenés éve: '
                  name="formMegjelenesEve"
                  id="formMegjelenesEve"
                  value={formMegjelenesEve}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-4">
                <DatetimePicker
                  label={'Bemutatás dátuma:'} 
                  // onChange={(e, v) => this.handleDateInputChange(e, v, 'formBemutato')}
                  onChange={(e,v) => {this.handleDateChange(e,v,'FORMBEMUTATAS')}}
                  onSelect={(e,v) => { this.selected = true }}
                  value={formBemutato && new Date(formBemutato)}
                  timePrecision="seconds"
                  id="formBemutato"
                  name="formBemutato"
                />
              </div>
              {this.props.type === 'MOD' && 
                <div className="col-md-4">
                  <RFField
                    label='Azonosító: '
                    disabled
                    name="formAzonosito"
                    id="formAzonosito"
                    value={formAzonosito}
                  />
                </div>
              }
            </div>
            <div className="row">
              <div className="col-md-4">
                <RFField
                  label='Rendező: '
                  onChange={this.handleInputChange}
                  name="formRendezo"
                  id="formRendezo"
                  value={formRendezo}
                  maxLength="150"
                />
              </div>
              <div className="col-md-6" style={{paddingRight: '2px'}}>
                  <SelectField
                    variant='creatable'
                    label='Szereplők:'
                    name="formSzereplok"
                    id="formSzereplok"
                    placeholder="Kezdj el gépelni..."
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    formatCreateLabel={this.formarCreateLabel}
                    onChange={v => this.setState({formSzereplok: v})}
                    onCreateOption={this.handleCreateSzereplo}
                    onDeleteOption={this.deleteSzereplo}
                    options={this.state.szereploOptions}
                    isMulti
                    getOptionLabel={option => option.label}
                    getOptionValue={option => option.value}
                    components={{Option: CustomOption}}
                    value={this.state.formSzereplok}
                    cache={false}
                    autoload={false}
                  />
              </div>
            </div>
          </React.Fragment>
        : <div />
        }
        <div className="row">
          <div className="col-md-2" hidden={!this.state.magyarSwitchButton}>
            <RFField
              regex={['^[0-9]*$', 'Számjegyek megadás lehetséges!']}
              label='Időtartam: (perc) '
              name="formIdotartam"
              id="formIdotartam"
              value={formIdotartam}
              onChange={this.handleInputChange}
            />
          </div>
          <div className="col-md-3" style={{paddingRight: '2px'}} hidden={!this.state.magyarSwitchButton}>
            <SelectField
              variant='creatable'
              label='Korhatár:'
              name="formKorhatar"
              id="formKorhatar"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              formatCreateLabel={this.formarCreateLabel}
              onChange={(v,t) => {this.setState({formKorhatar: v})}}
              onCreateOption={this.handleCreateKorhatar}
              onDeleteOption={this.deleteKorhatar}
              options={this.state.korhatarOptions}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              components={{Option: CustomOption}}
              value={this.state.formKorhatar}
              isClearable
            />
          </div>
          <div className="col-md-5" style={{paddingRight: '2px'}}>
            <SelectField
              variant='creatable'
              label='Műfajok:'
              name={mufajMezoString}
              id={mufajMezoString}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              formatCreateLabel={this.formarCreateLabel}
              onChange={v => {
                if (this.state.magyarSwitchButton == true)
                  this.setState({ formMufajok: v });
                else
                  this.setState({ formMufajokAngol: v });
              }}
              onCreateOption={this.handleCreateMufaj}
              onDeleteOption={this.deleteMufaj}
              isMulti
              options={this.state.mufajOptions.filter(m => m.angol == !this.state.magyarSwitchButton)}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              components={{Option: CustomOption}}
              value={this.state.magyarSwitchButton == true ? this.state.formMufajok : this.state.formMufajokAngol}
              cache={false}
              autoload={false}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <RFField
              label='Előzetes: '
              onChange={this.handleInputChange}
              name={elozetesMezoString}
              id={elozetesMezoString}
              value={this.state.magyarSwitchButton == true ? formElozetes : formElozetesAngol}
              maxLength="200"
            />
          </div> 
          <div className="col-md-4" hidden={!this.state.magyarSwitchButton}>
            <RFField
              onChange={this.handleInputChange}
              name="formForras"
              id="formForras"
              label='Forrás: '
              value={formForras}
            />
          </div>  
        </div>
        <div className="row">
          <div className="col-md-3" hidden={!this.state.magyarSwitchButton}>
            <h6>Plakát:*</h6>
            {!formPlakat &&
              <DropZone id="formPlakat" onDrop={this.onDropPlakat} className="custom-dropzone" accept="image/*">
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({ className: 'custom-dropzone'})}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Kép feltöltése!'}
                      </div>
                    </div>
                )}
                {/* <div className="dropzone-text">
                  {'Kép feltöltése!'}
                </div> */}
              </DropZone>
            }
            {formPlakat &&
              <ImageCard
                mime={formPlakat.mime}
                content={formPlakat.content}
                src={formPlakat.src}
                poster
                onViewClick={this.togglePlakatModal}
                onDeleteClick={() => {this.setState({formPlakat: null})}}
              />
            }
          </div>
          <div className="col-md-9">
            <RFField
              style={{height: '250px'}}
              type="textarea"
              label="Leírás: *"
              onChange={this.handleInputChange}
              name={leirasMezoString}
              id={leirasMezoString}
              maxLength="2500"
              value={this.state.magyarSwitchButton == true ? formLeiras : formLeirasAngol}
              required
            />
          </div>
        </div>
        <div className="row" hidden={!this.state.magyarSwitchButton}>
          <div className="col-md-1">
              <h6>Jelenetképek:</h6>
          </div>
          <div className="col-md-3" style={{paddingBottom: "15px"}}>
            <SelectField
              label='Elsődleges kép pozíció:'
              name="formKepPozicio"
              id="formKepPozicio"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => this.setState({formKepPozicio: v})}
              options={this.state.pozicioOptions}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              value={formKepPozicio}
              cache={false}
              isLoading={false}
              isClearable
            />
          </div>
        </div>
        <div className="row" hidden={!this.state.magyarSwitchButton}>
          <div className="col-md-12">
            <DropZone multiple onDrop={this.onDropJelenetKepek} className="custom-dropzone" style={{height: '50px'}}>
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({ className: 'custom-dropzone'})}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Kép feltöltése!'}
                      </div>
                    </div>
                )}
            </DropZone>
          </div>
        </div>
        <div className="row" hidden={!this.state.magyarSwitchButton}>
          {formJelenetkepek && formJelenetkepek.map((item, idx) => {
            return (
              <div className="col-md-3" key={idx.toString()}>
                <ImageCard
                  //style={{maxWidth: '200px'}}
                  key={idx.toString()}
                  mime={item.mime}
                  title={item.docname}
                  content={item.content}
                  main={item.main}
                  src={item.src}
                  style={{height: "200px"}}
                  onViewClick={e => this.toggleJelenetKepModal(idx)}
                  onMainImageClick={e =>{
                    formJelenetkepek.forEach((jK, idx2) => {
                      if(idx == idx2)
                        jK.main = true;
                      else
                        jK.main = false;
                    });
                    this.setState(formJelenetkepek);
                  }}
                  onDeleteClick={e => this.setState( (prevState) => ({formJelenetkepek: prevState.formJelenetkepek.filter(j => j.docname != item.docname)})) }
                />
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  }

  renderFormButtons = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <ProgressButton
            type='submit'
            color="primary"
            loading={this.state.saveButtonLoading}
            // onClick={this.submitForm}
          >
            Mentés
          </ProgressButton>
          {' '}
          <Button type="button" color="secondary" onClick={this.navToList}>
            Mégsem
          </Button>
        </div>
      </div>
    );
  }

  renderModals = () => {
    const {
      formPlakat,
      plakatModal,
      formJelenetkepek,
      jelenetKepModal,
      jelenetkepIndex,
      mafabModal,
    } = this.state;
    return (
      <React.Fragment>
          <RFForm
            onSubmit={this.loadMafabData}
            modalInsert
            title='Film betöltése'
            footer={
              <React.Fragment>
                <ProgressButton color="primary" type='submit' loading={this.state.importButtonLoading} >Betöltés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleMafabModal}>Mégsem</Button>
              </React.Fragment>
            }
            tagProps={{ isOpen: mafabModal, toggle: this.toggleMafabModal, backdrop: 'static' }}
          >
            <RFField
              name='cim'
              label='Cím: '
            />
              <RFField
              name='eredeti'
              label='Eredeti cím: '
            />
              <RFField
              name='ev'
              label='Megjelenés éve: '
            />
          </RFForm>
          <Card style={{marginBottom: "0", border: "none"}}>
            <Modal isOpen={plakatModal} toggle={this.togglePlakatModal} backdrop='static'>
              <RFForm onSubmit={() => {}}>
                {formPlakat &&
                  <React.Fragment>
                    <CardImg
                      src={ formPlakat.src ? formPlakat.src :  "data:image/bmp;base64," + formPlakat.content} 
                      onClick={this.togglePlakatModal}/>
                      <div className='row no-gutters'>
                        <div className='col'>
                          <RFField
                            //style={{height: '250px'}}
                            //className="munkalap-profil-textarea"
                            placeholder="Kép leírás..."
                            // type="text"
                            className="mb-0"
                            onChange={(e,v) => {this.setState( prevState => ({formPlakat: {...prevState.formPlakat, alt: v}}))}}
                            value={formPlakat.alt}
                            disabled={formPlakat.id}
                            name="formPlakatAltTag"
                          />
                        </div>
                        <div className='col-auto'>
                          <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.togglePlakatModal}>
                            OK
                          </Button>
                        </div>
                      </div>
                  </React.Fragment>
                }
              </RFForm>
            </Modal>
          </Card>
        <Modal isOpen={jelenetKepModal} toggle={this.toggleJelenetKepModal} backdrop="static">
          <RFForm onSubmit={() => {}}>
            <Card style={{marginBottom: "0", border: "none"}}>
                {formJelenetkepek && formJelenetkepek[jelenetkepIndex] &&
                  <React.Fragment>
                    <CardImg 
                      src={ formJelenetkepek[jelenetkepIndex].src ? formJelenetkepek[jelenetkepIndex].src :  "data:image/bmp;base64," + formJelenetkepek[jelenetkepIndex].content} 
                      onClick={this.toggleJelenetKepModal}/>
                    <div className='row no-gutters'>
                      <div className='col'>
                        <RFField
                          className="pull-left mb-0"
                          placeholder="Kép leírás..."
                          onChange={(e,v) => {
                            formJelenetkepek.forEach((jK, idx) => {
                              if(idx == jelenetkepIndex)
                                jK.alt = v;
                            });
                            this.setState(formJelenetkepek);
                          }}
                          disabled={formJelenetkepek[jelenetkepIndex].id}
                          value={formJelenetkepek[jelenetkepIndex].alt}
                          name="formJelenetAltTag"
                        />
                      </div>
                      <div className='col-auto'>
                        <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleJelenetKepModal}>
                          OK
                        </Button>
                      </div>
                    </div>
                  </React.Fragment>
                }
            </Card>
          </RFForm>
        </Modal>
      </React.Fragment>
    );
  } 

  render = () => {
    let cardStyle = {
      padding: 20
    };

    return (
      <div className="animated fadeIn">
        <div className="card">
          <span className="card-header">
            {this.renderFormTitle()}
            {this.props.type === 'FEL' && this.props.globals.hasRoleSpec(['ELOADAS_MAFAB']) && 
              <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleMafabModal}>
                Mafab betöltés
              </Button>
            }
          </span>
          <div style={cardStyle}>
            {this.state.loading ?
              <Loader /> :
              <React.Fragment>
                <RFForm onSubmit={this.submitForm}>
                  {this.renderForm()}
                  {this.renderFormButtons()}
                </RFForm>
                {this.renderModals()}
              </React.Fragment>
            }
          </div>
        </div>
      </div>
    );
  }
}

EloadasForm.propTypes = {
  globals: PropTypes.object
};



export default EloadasForm;
